import React from "react";

export const isObjectEmpty = (data: {}) => {
  if (data === null || data === undefined) return false;

  return Object.keys(data).length === 0;
};
